import { useState } from 'react';
import { HttpMethod, HttpWrapper } from '../../../../../helpers/httpWrapper';
import {
	ICommunityDynamicLinkUpdateRequest,
	ICommunityDynamicLinkUpdateResponse,
	VCommunityDynamicLinkUpdate,
} from '../../../../../networked-shared-interfaces/interfaces-phase2/platform-admin/sub-routes/community';
import { URLWrapper } from '../../../../../networked-shared-interfaces/url-wrapper';
import { toastService } from '../../../../../services/toast.service';

interface IDynamicLinkState {
	loading: boolean;
	error: string | null;
	saved: boolean;
}

export interface IDynamicLinkFormValues {
	ios: string;
	android: string;
	appId: string;
	branch_key: string;
	branch_secret: string;
}

export const useCommunityDynamicLink = () => {
	const [state, setState] = useState<IDynamicLinkState>({
		loading: false,
		error: null,
		saved: false,
	});

	const saveDynamicLink = async (
		communityId: string,
		values: IDynamicLinkFormValues
	): Promise<boolean> => {
		setState({ loading: true, error: null, saved: false });

		try {
			const body: any = { communityId };

			// Only send non-empty fields so we don't accidentally clear server-side values.
			if (values.ios) body.ios = values.ios;
			if (values.android) body.android = values.android;
			if (values.appId) body.appId = values.appId;
			if (values.branch_key) body.branch_key = values.branch_key;
			if (values.branch_secret) body.branch_secret = values.branch_secret;

			await HttpWrapper.callUrl<ICommunityDynamicLinkUpdateRequest, ICommunityDynamicLinkUpdateResponse>(
				URLWrapper.urls.platformAdmin.communityDynamicLink,
				HttpMethod.PUT,
				body,
				VCommunityDynamicLinkUpdate
			);

			setState({ loading: false, error: null, saved: true });
			toastService.success('Branch credentials saved successfully!');
			return true;
		} catch (err: any) {
			const message = err?.message || 'Failed to save Branch credentials.';
			setState({ loading: false, error: message, saved: false });
			toastService.error(message);
			return false;
		}
	};

	return { ...state, saveDynamicLink };
};
